import { markRaw } from 'vue'
import EventHeaderView from './EventHeaderView.vue'
import schema from './schema'

export default {
  viewComponent: markRaw(EventHeaderView),
  editorSchema: schema,
  editorData: {},
}
